import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
  provideEnvironmentInitializer,
  provideZoneChangeDetection,
  APP_INITIALIZER,
} from '@angular/core';
import { AppRoutingModule } from './app.routes';
import {
  AuthInterceptor,
  AuthModule,
  LogLevel,
} from 'angular-auth-oidc-client';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '../environments/environment';
import { WindowService } from '@shared/tools/window.service';
import { LOGIN_PAGE, LOGOUT_PAGE } from '@shared/constants/routing-constants';
import { KaufmannSettingsService } from './modules/settings/services/kfm-settings.service';
import { HS_BLAZOR_APP_INITIALIZER } from '@hsetu/core-services';
import { provideHsLocalization } from '@hsetu/ngui-resources';
import { provideTranslateService } from '@ngx-translate/core';
import { KfmFinancialRepository } from '@shared/financial/kfm-financial.repository';
import { HS_FINANCIAL_REPOSITORY } from '@hsetu/ngui-modules-financial';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideEnvironmentInitializer(() => inject(WindowService)),
    provideTranslateService({ fallbackLang: 'de' }),
    provideHsLocalization(),
    HS_BLAZOR_APP_INITIALIZER,
    {
      provide: APP_INITIALIZER,
      useFactory: (settingsService: KaufmannSettingsService) => {
        return () => settingsService.loadSettings();
      },
      deps: [KaufmannSettingsService],
      multi: true,
    },
    importProvidersFrom(
      AppRoutingModule,
      AuthModule.forRoot({
        config: {
          configId: environment.auth.configId,
          authority: environment.auth.authority,
          redirectUrl: window.location.origin + '/' + LOGIN_PAGE,
          postLogoutRedirectUri: window.location.origin + '/' + LOGOUT_PAGE,
          clientId: environment.auth.clientId,
          scope: environment.auth.scopes,
          responseType: 'code',
          silentRenew: true,
          useRefreshToken: true,
          tokenRefreshInSeconds: 60,
          renewTimeBeforeTokenExpiresInSeconds: 60,
          logLevel: LogLevel.Debug,
        },
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HS_FINANCIAL_REPOSITORY, useClass: KfmFinancialRepository },
  ],
};
